module.exports = __webpack_public_path__ + "img/20191018162820856.f5f0a0d9.jpg";